module.exports = __webpack_public_path__ + "static/media/shape2_7.da77f55f.obj";